var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ShiftOpportunityType } from '@amzn/atoz-shiftapp-types';
import { DateTime, Interval } from 'luxon';
import { useEffect, useState, useMemo } from 'react';
export function days(interval) {
    var cursor;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                cursor = interval.start.startOf('day');
                _a.label = 1;
            case 1:
                if (!(cursor <= interval.end)) return [3 /*break*/, 3];
                return [4 /*yield*/, cursor];
            case 2:
                _a.sent();
                cursor = cursor.plus({ days: 1 });
                return [3 /*break*/, 1];
            case 3: return [2 /*return*/];
        }
    });
}
export var useNumberOfOpportunitiesPerDay = function (_a) {
    var timeRange = _a.timeRange, opportunities = _a.opportunities, counts = _a.counts;
    var interval = useMemo(function () {
        return Interval.fromDateTimes(DateTime.fromISO(timeRange.start), DateTime.fromISO(timeRange.end));
    }, [timeRange.start, timeRange.end]);
    var daysWithOpportunityCountInitialState = useMemo(function () {
        return Array.from(days(interval)).reduce(function (acc, cur) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[cur.toISODate()] = {
                count: 0,
                numberIneligible: 0
            }, _a)));
        }, {});
    }, [interval]);
    var _b = useState(daysWithOpportunityCountInitialState), daysWithOpportunityCount = _b[0], setDaysWithOpportunityCount = _b[1];
    useEffect(function () {
        var daysWithOpportunity = {};
        if (opportunities) {
            opportunities.forEach(function (opportunity) {
                var _a;
                var startDateTime = DateTime.fromISO(opportunity.shift.timeRange.start);
                if (!interval.contains(startDateTime)) {
                    return;
                }
                var startTime = startDateTime.toISODate();
                var type = opportunity.type;
                var isAddOpportunity = type === ShiftOpportunityType.Add ||
                    type === ShiftOpportunityType.VoluntaryExtraTime;
                var isEligible = (_a = opportunity.eligibility) === null || _a === void 0 ? void 0 : _a.isEligible;
                if (daysWithOpportunity[startTime] === undefined) {
                    daysWithOpportunity[startTime] = {
                        count: 0,
                        numberIneligible: 0
                    };
                }
                if (isEligible && isAddOpportunity && !counts) {
                    daysWithOpportunity[startTime].count += 1;
                }
                if (!isEligible && isAddOpportunity) {
                    daysWithOpportunity[startTime].numberIneligible += 1;
                }
            });
        }
        if (counts) {
            counts.forEach(function (countForDay) {
                var startDateTime = DateTime.fromISO(countForDay.date);
                if (!interval.contains(startDateTime)) {
                    return;
                }
                var startTime = startDateTime.toISODate();
                if (daysWithOpportunity[startTime] === undefined) {
                    daysWithOpportunity[startTime] = {
                        count: 0,
                        numberIneligible: 0
                    };
                }
                if (daysWithOpportunity[startTime].count == 0) {
                    daysWithOpportunity[startTime].count += countForDay.count;
                }
            });
        }
        setDaysWithOpportunityCount(__assign(__assign({}, daysWithOpportunityCount), daysWithOpportunity));
    }, [opportunities, counts]);
    return Object.entries(daysWithOpportunityCount).map(function (_a) {
        var date = _a[0], _b = _a[1], count = _b.count, numberIneligible = _b.numberIneligible;
        return {
            date: DateTime.fromISO(date),
            count: count,
            numberOfIneligible: numberIneligible
        };
    });
};
